import { UserAuthWrapper } from 'redux-auth-wrapper';
import {
    loadingMeSelector,
} from 'common/permissions/selectors';
import {
    studyFeatureAccess,
    emailReminderFeatureAccess,
} from 'common/features/predicates';

export const UserHasEmailRemindersFeatureAccess = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: emailReminderFeatureAccess,
    FailureComponent: null
});

export const UserHasStudyFeatureAccess = UserAuthWrapper({
    authSelector: state => state,
    authenticatingSelector: loadingMeSelector,
    predicate: studyFeatureAccess,
    FailureComponent: null
});
